import { ScoreColor } from './models';

export const DEFAULT_SCORE_COLORS: ScoreColor[] = [
  { color: '#7B7B7B', textColor: '#ffffff', riskLevel: 'common.risk-level.no-data' },
  { color: '#E53835', textColor: '#ffffff', riskLevel: 'common.risk-level.extreme' },
  { color: '#FB8C00', textColor: '#2b2b2b', riskLevel: 'common.risk-level.high' },
  { color: '#FBC02D', textColor: '#2b2b2b', riskLevel: 'common.risk-level.medium' },
  { color: '#CDDC39', textColor: '#2b2b2b', riskLevel: 'common.risk-level.low' },
];

export const DEFAULT_SUBNATIONAL_MAP_SCORE_COLORS: ScoreColor[] = [
  { color: '#7B7B7B', textColor: '#ffffff', riskLevel: 'common.risk-level.no-data' },
  { color: '#FF0000', textColor: '#ffffff', riskLevel: 'common.risk-level.extreme' },
  { color: '#f5983b', textColor: '#2b2b2b', riskLevel: 'common.risk-level.high' },
  { color: '#faf68c', textColor: '#2b2b2b', riskLevel: 'common.risk-level.medium' },
  { color: '#8db31b', textColor: '#2b2b2b', riskLevel: 'common.risk-level.low' },
];
